module.exports = __webpack_public_path__ + "assets/img/6.5cc0803c.png";